import { Tour as AntTour, GetProps } from 'antd';

export const Tour = AntTour;

export type TourProps = GetProps<typeof AntTour>
